import { BillingTarget } from '@/hooks/api/models';
import axios from '@/lib/axios';
import { useQuery } from '@tanstack/react-query';

/**
 * 1200. 支払元（請求先）区分一覧
 * [GET] /billing_targets
 */
const billingTargets = (): Promise<BillingTarget[]> => {
  return axios.get(`/api/billing_targets`);
};

export const useBillingTargets = () => {
  return useQuery({
    queryKey: ['billing_targets'],
    queryFn: () => billingTargets(),
  });
};